// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"170":"5ee5a14a","777":"1852f513","783":"1852f513"}[chunkId] + ".chunk.css";
};